import Vue from 'vue'
import Vuex from 'vuex'
import ExaminerAPIClient from '@/api/examiner'
import { setStateItem } from '@/utils/utils.store'
import notify from '@/store/modules/notify'
import { webRTCConfiguration } from '@/config'
import { P2PClient } from '@examus/webrtc-client'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    notify
  },
  state: {
    loading: false,
    loadingError: false,
    user: null,
    loggingIn: false,
    token: null,
    refreshToken: null,
    refreshInProgress: false,
    refreshRequest: null,
    client: new ExaminerAPIClient(),
    p2pClient: null,
  },
  mutations: {
    setLoggingIn: setStateItem('loggingIn'),
    setLoading: setStateItem('loading'),
    setLoadingError: setStateItem('loadingError'),
    setUser: setStateItem('user'),
    setToken: setStateItem('token'),
    setRefreshToken: setStateItem('refreshToken'),
    setRefreshStatus: setStateItem('refreshInProgress'),
    setRefreshRequest: setStateItem('refreshRequest'),
    setP2PClient: setStateItem('p2pClient'),
    logout (state) {
      localStorage.removeItem('access')
      localStorage.removeItem('refresh')
      state.refreshToken = null
      state.refreshRequest = null
      state.refreshInProgress = false
    }
  },
  actions: {
    setLoading ({ commit }, loadingState) {
      commit('setLoading', loadingState)
    },
    setUserData ({ state, commit }, userData) {
      commit('setToken', userData.access_token)
      commit('setRefreshToken', userData.refresh_token)
      commit('setUser', userData.user)
      localStorage.setItem('refresh', JSON.stringify(userData.refresh_token))
      localStorage.setItem('access', JSON.stringify(userData.access_token))
    },
    login ({ state, dispatch }, { email, password }) {
      return state.client.login(email, password)
    },
    logout ({ commit }) {
      commit('logout')
      commit('setUser', null)
      commit('setToken', null)
      commit('killP2PClient')
    },
    fetchUser ({ state }) {
      return state.client.getUser()
    },
    makeP2PClient ({ state, commit }) {
      return new Promise(resolve => {
        if (!state.p2pClient) {
          commit('setP2PClient', new P2PClient({
            token: state.user.signaling_token, // TODO: How to update the token?)
            configuration: webRTCConfiguration
          }))
          console.log('P2P CLIENT CREATED')
        }
        resolve()
      })
    },
    killP2PClient ({ state, commit }) {
      if (state.p2pClient) {
        state.p2pClient.stop()
      }
      commit('setP2PClient', null)
      console.log('P2P CLIENT KILLED')
    },
    refreshToken ({ state }) {
      return state.client.refreshToken(state.refreshToken)
    },
    changePassword ({ state }, payload) {
      return this.state.client.changePassword(payload)
    },
    createNewExam ({ state }, exam) {
      return state.client.createNewExam(exam)
    },
    createNewExaminer ({ state }, examiner) {
      return state.client.createNewExaminer(examiner)
    },
    editExam ({ state }, { examId, exam }) {
      return state.client.editExam(examId, exam)
    },
    deleteExamAction ({ state }, examId) {
      return state.client.deleteExam(examId)
    },
    fetchCompanyUsers ({ state }, companyId) {
      return state.client.getCompanyUsers(companyId)
    },
    fetchExams ({ state }) {
      return state.client.getExamList()
    },
    fetchExam ({ state }, id) {
      return state.client.getExam(id)
    },
    fetchExamStudents ({ state }, id) {
      return state.client.getExamStudents(id)
    },
    fetchExamCommission ({ state }, id) {
      return state.client.getExamCommission(id)
    },
    fetchExamPapers ({ state }, id) {
      return state.client.getExamPapers(id)
    },
    sendPaperToStudent ({ state }, { studentId, paperId }) {
      return state.client.sendStudentPaper(studentId, paperId)
    },
    updateStudentStatus ({ state }, { studentId, status }) {
      return state.client.sendStudentStatus(studentId, status)
    },
    uploadPapers ({ state }, { examId, papers }) {
      return state.client.uploadPapers(examId, papers)
    },
    uploadStudents ({ state }, { examId, students }) {
      return state.client.uploadStudents(examId, students)
    }
  },
  getters: {
    loggedIn: state => !!state.user,
    isStaff: state => state.user && state.user.is_staff
  }
})
